const serverConstants = {
  host: process.env.REACT_APP_AUTH_BASE_PATH,
  serverCredentials: `${process.env.REACT_APP_CLIENT_ID}:${process.env.REACT_APP_CLIENT_SECRET}`,
  superRoleName: 'SUPER',
  adminRoleName: 'ADMIN',
  approverRoleName: 'APPROVER',
  underwriterRoleName: 'UNDERWRITER',
  accountantRoleName: 'ACCOUNTANT',
  paymentManagerRoleName: 'PAYMENT_MANAGER',
}

export default serverConstants



// WEBPACK FOOTER //
// ./src/redux/sagas/authServerConstans.js